import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Divider } from "@mui/material";

// Material UI components
import AppBar from "@mui/material/AppBar";
import { withStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// Actions
import { userActions } from "../../../store/actions/userActions";
// import { userService } from "../../../store/services/userService";
import { globalAlertService } from "../../../store/services/shared/globalAlertService";
import { verimiAdminService } from "../../../store/services/admin/verimiAdminService";
import { notificationActions } from "../../../store/actions/notification/notificationActions";
import { vorgangeListActions } from "../../../store/actions/vorgange/vorgangeListAction";
import { finWhiteListActions } from "../../../store/actions/appLoginDashboard/finWhiteListActions";
import { appLoginDashboardActions } from "../../../store/actions/appLoginDashboard/appLoginDashboardAction";
import { csvImportExportAction } from "../../../store/actions/exportImportFile/csvImportExportAction";
import { socketActions } from "../../../store/actions/socket/socketActions";

// Assets
import profileLogo from "../../../assets/images/icon_profil.svg";
import carLogo from "../../../assets/images/my_digital_car.svg";
import KBACertificate from "../../../assets/images/KBACertificate.svg";
import DownloadFileIcon from "../../iconComponents/DownloadFileIcon";
import RightArrowIcon from "../../iconComponents/RightArrowIcon";
import NotificationBellIcon from "../../iconComponents/NotificationBellIcon";

// Components
import GlobalAlert from "../../shared/GlobalAlert";
import NotificationDialog from "./NotificationDialog";
import MessageDetailsPopupDialog from "./MessageDetailsPopupDialog";
import MDCBadge from "../../core/MDCBadge";
import NotificationMessage from "../../core/NotificationMessage";
import StatusServiceMessages from "./StatusServiceMessages";
import MultipleLoginDrawer from "./MultipleLoginDrawer";

//Constants
import {
  EMP_ID_MISSING_ERROR,
  TENANT_INFO_MISSING_ERROR,
} from "../../../constants/messageConstants";
import {
  USER_ROLE_ADMIN,
  USER_ROLE_MDC_ADMIN,
  USER_ROLE_SUPPORT,
  USER_ROLE_API_USER,
  USER_ROLE_EXPERT,
  USER_ROLE_ACCOUNTANT,
  USER_ROLE_APPROVER,
} from "../../../constants/userConstants";
import {
  HIST_NOTIFICATIONS,
  READ_NOTIFICATIONS,
  NEW_NOTIFICATION,
  TENANT_CREATION_STATUS_SUCCESS_FROM_SOCKET,
  CSV_IMPORT_PROCESSED,
} from "../../../constants/notificationConstants";
import {
  CSV_FILE_UPLOAD_ERROR_FROM_SOCKET,
  CSV_FILE_UPLOAD_SUCCESS_FROM_SOCKET,
} from "../../../constants/FinwhiteListConstants";
import {
  EVENT,
  KEEP_ALIVE,
  SOCKET_READY_STATE_OPEN,
  VORGANG_QES_UPDATED,
  VORGANG_UPDATED,
} from "../../../constants/socketConstants";
import { HTTP_SUCCESS_CODE_200 } from "../../../constants/VorgangDetailsConstants";

// Helper
import { history } from "../../../helpers/history";
import { getFileExtension } from "../../../helpers/fileExtension";
import Container from "@mui/material/Container";
import { config } from "../../../store/services/config";

// Theme
import theme from "../../../themes/mdc-theme";

// Utils
import { hasRolePermissions } from "../../../helpers/utils";

// Constants
import { COMPONENT_IDS } from "../../../constants/RolePermissions";

// Inner Components
import NewsAndUpdatesOverviewPopup from "./inner_components/NewsAndUpdatesOverviewPopup";
import CSVExcelUploadImport from "./inner_components/CSVExcelUploadImport";
import SessionTimeoutWarning from "./inner_components/SessionTimeoutWarning";

let socketKeepAliveId = null;

const styles = (theme) => ({
  root: {
    "&.MuiPaper-root": { backgroundColor: "initial" },
    fontFamily: theme.palette.typography.fontFamily,
  },
  profileList: {
    "& ul[role='menu']": {
      flexDirection: "column",
    },
    "& .MuiMenuItem-root": {
      fontFamily: theme.palette.typography.fontFamily,
    },
  },
  downloadsStyles: {
    "& .MuiPaper-root": {
      left: "76% !important",
      top: "27% !important",
    },
  },
  administrationLabel: {
    color: theme.palette.MDCColors.color23,
    fontSize: "2rem",
    marginLeft: "10%",
    alignSelf: "flex-end",
    fontWeight: "bold",
    marginTop: "1rem",
  },
  dashboardLink: {
    paddingTop: "14px",
    cursor: "pointer",
    color: theme.palette.MDCColors.color23,
    fontSize: "1.125rem",
    fontWeight: "600",
    textDecoration: "underline",
    paddingLeft: "4rem",
    "& a": {
      color: theme.palette.MDCColors.textColor,
    },
  },
  imgFluid: {
    maxWidth: "100%",
    height: "auto",
  },
  cursorPointer: {
    cursor: "pointer",
  },
  downloadFileIconStyles: {
    color: theme.palette.MDCColors.color23,
    marginRight: "1rem",
  },
  headerBackground: { backgroundColor: theme.palette.MDCColors.white },
  responsiveDivider: {
    "&.MuiDivider-root": {
      border: "2.8px solid #E8E8E8",
      alignItems: "center",
      opacity: 1,
      marginTop: "0.5rem",
      marginLeft: "1.1rem",
      minHeight: "2rem",
      maxHeight: "7rem",
      [theme.breakpoints.down("md")]: {
        height: "50%",
      },
      [theme.breakpoints.down("sm")]: {
        height: "35%",
      },
    },
  },
});

const activeUserFromSession = sessionStorage.getItem("activeUser");
const activeUserFromLocal = localStorage.getItem("activeUser");
const activeUserStorageValue = activeUserFromSession
  ? activeUserFromSession
  : activeUserFromLocal;
let activeUser = JSON.parse(activeUserStorageValue);
const tenantAlias = activeUser?.value;
const tenantGroupID = activeUser?.groupID;

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.state = {
      lastUpdated: "10:30",
      filePreview: "",
      fileName: "",
      showNotificationDialog: false,
      data: [],
      anchorProfile: null,
      notificationsData: [],
      openDownloads: false,
      groupStatusMessages: [],
      showMessageDetail: false,
      messageDetails: "",
      showNewsAndUpdates: true,
      aliasName: "",
      anchorElExcelUpload: null,
    };
  }

  componentDidMount = () => {
    this.logoutChannel.onmessage = (event) => {
      if (
        event.data?.type === "SESSION_LOGOUT" ||
        event.data?.type === "SESSION_EXPIRED"
      ) {
        this.isLoggingOut = true;
        if (this.socket) {
          this.socket.onclose = null;
          this.socket.close();
          this.socket = null;
        }

        sessionStorage.clear();
        // Only show "session expired" popup for session expiry, not for intentional logout
        if (event.data?.type === "SESSION_EXPIRED") {
          sessionStorage.setItem("isSessionTimedout", "true");
        }
        window.location.replace("/login");
      } else if (event.data?.type === "SESSION_WARNING") {
        // Another tab detected inactivity — show the warning popup in this tab too
        this.props.showLogoutWarningTimer(true);
      }
    };

    const aliasName =
      history?.location?.pathname === "/tenant"
        ? history?.location?.state?.aliasName
        : tenantAlias;
    this.setState({ aliasName });
    if (aliasName) {
      this.checkForGlobalError(aliasName);
      this.getNotifications(aliasName);
      const isMDCAdmin = this.props?.user?.roles?.includes(USER_ROLE_MDC_ADMIN);

      if (!isMDCAdmin) {
        this.props.getNewsAndUpdatesList(tenantGroupID, aliasName);
      }
    }

    if (aliasName && !this.props?.user?.roles?.includes(USER_ROLE_MDC_ADMIN)) {
      this.props
        .getGroupStatusMessages(tenantGroupID, tenantAlias)
        .then((resp) => {
          if (resp?.status === 200 && resp?.data) {
            this.setState({ groupStatusMessages: resp.data });
          }
        });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.user !== prevProps.user) {
      this.checkForGlobalError(
        history?.location?.pathname === "/tenant"
          ? history?.location?.state?.aliasName
          : tenantAlias
      );
    }
    if (this.state.notificationsData !== prevState.notificationsData) {
      if (this.state.notificationsData?.length === 0) {
        this.setState({ showNotificationDialog: false });
      }
    }
  }

  componentWillUnmount() {
    clearInterval(socketKeepAliveId);
    this.logoutChannel.close();
  }

  isLoggingOut = false;
  socket = null;
  logoutChannel = new BroadcastChannel("mdc_auth");

  handleClickProfile = (event) => {
    this.setState({ anchorProfile: event.currentTarget, openDownloads: false });
  };
  handleCloseProfile = () => {
    this.setState({ anchorProfile: null });
  };
  handleClickDownloads = () => {
    this.setState({
      openDownloads: true,
    });
  };

  handleCloseDownloads = () => {
    this.setState({ openDownloads: false });
  };

  // Clear browser storage on logout
  clearBrowserStorage = () => {
    this.isLoggingOut = true;
    if (this.socket) {
      this.socket.onclose = null;
      this.socket.close();
      this.socket = null;
    }
    this.logoutChannel.postMessage({ type: "SESSION_LOGOUT" });
    localStorage.clear();
    sessionStorage.clear();
  };

  handleOpen = (e) => {
    this.setState({ anchorElExcelUpload: e.currentTarget });
  };

  handleClose = () => this.setState({ anchorElExcelUpload: null });

  onLogout(e) {
    e.preventDefault();
    this.clearBrowserStorage();
    window.location.replace(`${config.apiUrl}/users/kclogout`);
  }

  logoutOnSessionExpiry() {
    this.isLoggingOut = true;
    if (this.socket) {
      this.socket.onclose = null;
      this.socket.close();
      this.socket = null;
    }
    this.logoutChannel.postMessage({ type: "SESSION_EXPIRED" });
    localStorage.clear();
    sessionStorage.clear();
    sessionStorage.setItem("isSessionTimedout", "true");
    window.location.replace("/login");
  }

  // Get File Name For Document
  getFileNameFromHttpResponse = (httpResponse) => {
    return (httpResponse && httpResponse.headers["x-suggested-filename"]) || "";
  };

  handleBlobData = (fileData, fileName) => {
    const url = window.URL.createObjectURL(
      new Blob([fileData], { type: "application/pdf" })
    );

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName); //or any other extension
    document.body.appendChild(link);
    link.click();
  };

  downloadTemplate = (docType) => {
    this.setState({ anchorProfile: null });
    let fileName, fileData;
    switch (docType) {
      case "Dauervollmacht":
        this.props.getTempaltePDF("dauervollmacht").then(() => {
          fileData = this.props?.tempaltePDF?.data;
          fileName = this.getFileNameFromHttpResponse(this.props?.tempaltePDF);
          this.handleBlobData(fileData, fileName);
        });

        break;
      case "SEPA":
        this.props.getTempaltePDF("sepa-mandat").then(() => {
          if (this.props?.tempaltePDF?.status === 200) {
            fileName = this.getFileNameFromHttpResponse(
              this.props?.tempaltePDF
            );
            fileData = this.props?.tempaltePDF?.data;
            this.handleBlobData(fileData, fileName);
          }
        });
        break;
      case "Einzelvollmacht":
        this.props.getTempaltePDF("einzelvollmacht").then(() => {
          if (this.props?.tempaltePDF?.status === 200) {
            fileName = this.getFileNameFromHttpResponse(
              this.props?.tempaltePDF
            );
            fileData = this.props?.tempaltePDF?.data;
            this.handleBlobData(fileData, fileName);
          }
        });
        break;
    }
  };

  refreshTable = (notificationData) => {
    // Notify dashboard table component(VorgangList) that web socket notification is triggered for Einreichen request
    if (notificationData) {
      this.props.isDashboardTableEinreichenNotification(true, notificationData);
    } else {
      this.props.isDashboardTableCSVImportNotification(true);
    }
    // Refresh table once record is processed
    this.props.getVorgangeList(this.props.dashboardTableQuery, "insgesamt");
  };

  showNotification = (notificationsSocketData, isRefreshTable) => {
    if (notificationsSocketData.messageType === "error") {
      toast.error(
        <NotificationMessage
          requestId={notificationsSocketData?.requestId}
          primaryReference={notificationsSocketData?.primaryReference}
          message={notificationsSocketData?.message}
        />
      );
    } else if (notificationsSocketData.messageType === "info") {
      toast.info(
        <NotificationMessage
          requestId={notificationsSocketData?.requestId}
          primaryReference={notificationsSocketData?.primaryReference}
          message={notificationsSocketData?.message}
          linkIdentifier={notificationsSocketData?.linkIdentifier}
          hasHyperlink={notificationsSocketData?.hasHyperlink}
        />
      );
    } else {
      toast.success(
        <NotificationMessage
          requestId={notificationsSocketData?.requestId}
          primaryReference={notificationsSocketData?.primaryReference}
          message={notificationsSocketData?.message}
          linkIdentifier={notificationsSocketData?.linkIdentifier}
          hasHyperlink={notificationsSocketData?.hasHyperlink}
        />
      );
    }
    const isDashboardPage = window.location.pathname === "/dashboard"; //using this to prevent unneccesary calling of vorgangs API on different pages
    if (isRefreshTable && isDashboardPage) {
      this.refreshTable(notificationsSocketData);
    }
  };

  handleNewNotification = (notificationsSocketData, notificationType) => {
    if (notificationType === NEW_NOTIFICATION) {
      this.setState({
        notificationsData: [
          notificationsSocketData,
          ...this.state?.notificationsData,
        ],
      });
    }

    if (
      notificationsSocketData?.message?.includes(
        CSV_FILE_UPLOAD_SUCCESS_FROM_SOCKET
      ) ||
      notificationsSocketData?.message?.includes(
        CSV_FILE_UPLOAD_ERROR_FROM_SOCKET
      )
    ) {
      // Need to add the condition for fin white list
      this.props.getFinWhiteListStatusDetails(localStorage.getItem("groupId"));
      this.showNotification(notificationsSocketData);
    } else if (
      notificationsSocketData?.message?.includes(
        TENANT_CREATION_STATUS_SUCCESS_FROM_SOCKET
      )
    ) {
      // will update tenant status once all tenants processing is done
      this.props.getCreateTenantStatus(localStorage.getItem("groupId"));
      this.showNotification(notificationsSocketData);
    } else {
      this.showNotification(notificationsSocketData, true); //Sending true attribute for refreshing the table
    }
  };

  handleEvents(eventsData) {
    const isApprover = this.props?.user?.roles?.includes(USER_ROLE_APPROVER);

    const { eventType, recordId } = eventsData;
    if (eventType === VORGANG_UPDATED) {
      this.props.getVorgangUpdatedIdFromSocketEvent(recordId);
    } else if (eventType === VORGANG_QES_UPDATED) {
      this.props.getVorgangQESUpdatedFromSocketEvent(recordId);
    } else if (eventType === CSV_IMPORT_PROCESSED && isApprover) {
      // Handle CSV Import type notifications
      this.props.getCSVUploadedAndErrorFile();
      // After CSV import processed, refresh the table
      this.refreshTable();
    }
  }

  getNotifications = (aliasName) => {
    if (aliasName) {
      this.props.getTokenForWebsocket().then((resp) => {
        if (resp?.data && resp?.status === HTTP_SUCCESS_CODE_200) {
          const token = resp.data;
          this.connectToWebSocket(token);
        }
      });
    }
  };

  connectToWebSocket = (token) => {
    const protocol = config?.apiUrl?.split(":")[0] === "http" ? "ws" : "wss";
    const host = new URL(config.apiUrl).host;
    const socketUrl = `${protocol}://${host}/notifications/ws?token=${token}`;

    let socket = new WebSocket(socketUrl);
    this.socket = socket;

    if (socket) {
      socket.onmessage = (event) => {
        if (event?.data) {
          let vorgangNotificationsData = JSON.parse(event?.data);
          const vorgangNotifications = vorgangNotificationsData?.data;

          // History notifications data received only first time socket connection is established
          if (vorgangNotificationsData?.type === HIST_NOTIFICATIONS) {
            this.setState({
              notificationsData: vorgangNotifications,
            });
            // Read only notification data
          } else if (vorgangNotificationsData?.type === READ_NOTIFICATIONS) {
            this.setState({
              notificationsData: this.state.notificationsData?.filter(
                (item) => !vorgangNotifications?.includes(item.messageId)
              ),
            });
            // Will be received for success or error case
          } else if (vorgangNotificationsData?.type === EVENT) {
            // Handle event type notifications
            this.handleEvents(vorgangNotifications);
          } else {
            this.handleNewNotification(
              vorgangNotifications,
              vorgangNotificationsData?.type
            );
          }
        }
      };

      socket.onclose = () => {
        clearInterval(socketKeepAliveId);
        socket = null;
        this.socket = null;
        // Only reconnect if user is still logged in and not in logout process
        if (!this.isLoggingOut && localStorage.getItem("user")) {
          this.getNotifications(this.state.aliasName);
        }
      };

      //keep socket connection alive
      socketKeepAliveId = setInterval(() => {
        if (socket.readyState === SOCKET_READY_STATE_OPEN) {
          socket?.send(KEEP_ALIVE);
        }
      }, 29000);
    }
  };

  getUpdatedLogo = async (aliasName) => {
    if (aliasName) {
      const logo = await verimiAdminService.getDetail(aliasName, "logo");
      if (logo && logo.file && !logo.isAxiosError) {
        const fileExtension = getFileExtension(logo?.fileName);
        //If image is of svg type then we are adding type: "image/svg+xml" for proper Blob URL object"
        const imageBlobData =
          fileExtension === "svg"
            ? new Blob([logo.file], {
                type: "image/svg+xml",
              })
            : logo.file;

        const imageDataURL = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result || "");
          reader.readAsDataURL(imageBlobData);
        });

        this.setState({
          fileName: logo?.fileName,
          filePreview: imageDataURL,
        });
      }
    }
  };

  checkForGlobalError = async (aliasName) => {
    let errorMessage;

    const isApprover = this.props?.user?.roles?.includes(USER_ROLE_APPROVER);

    if (aliasName) {
      await this.getUpdatedLogo(aliasName);
      await this.props.getCompanyDetails(aliasName);

      if (isApprover) {
        await this.props.getCSVUploadedAndErrorFile();
      }
    }

    let gksDetailsMissing = !this.props.companyDetails?.gksDetailsPresent;

    let autoClose = false;
    let closeIcon = false;
    let keepAfterRouteChange = false;
    let empIdMissing = this.props?.user?.employeeId ? false : true;
    if (empIdMissing || gksDetailsMissing) {
      globalAlertService.clear();
      if (empIdMissing) {
        errorMessage = EMP_ID_MISSING_ERROR;
        globalAlertService.error(errorMessage, {
          autoClose,
          keepAfterRouteChange,
          closeIcon,
          forwardLink: "/profile",
        });
      } else {
        globalAlertService.clear();
      }

      const isAdmin = this.props?.user?.roles?.includes(USER_ROLE_ADMIN);
      const isAPIUser = this.props?.user?.roles?.includes(USER_ROLE_API_USER);

      if (gksDetailsMissing) {
        errorMessage = TENANT_INFO_MISSING_ERROR;
        const options = {
          autoClose,
          keepAfterRouteChange,
          closeIcon,
        };
        if (isAdmin || isAPIUser) {
          options.forwardLink = "/admin";
        }
        setTimeout(() => {
          globalAlertService.error(errorMessage, options);
        }, 1);
      }
    } else {
      globalAlertService.clear();
    }
  };

  handleNotification = () => {
    this.setState({
      showNotificationDialog: false,
    });
  };

  showMessageDetailDialog = (messageDetails) => {
    this.setState({ showMessageDetail: true, messageDetails: messageDetails });
  };

  handleNewAndUpdatesClose = () => {
    this.setState({
      showNewsAndUpdates: false,
    });
  };

  handleOriginNavigation = () => {
    sessionStorage.setItem("origin", window.location.pathname);
  };

  render() {
    const { showNotificationDialog, anchorProfile, openDownloads } = this.state;

    const isAdmin = this.props?.user?.roles?.includes(USER_ROLE_ADMIN);
    const isAPIUser = this.props?.user?.roles?.includes(USER_ROLE_API_USER);
    const isApprover = this.props?.user?.roles?.includes(USER_ROLE_APPROVER);
    const isApproverOrSupport =
      this.props?.user?.roles?.includes(USER_ROLE_APPROVER) ||
      this.props?.user?.roles?.includes(USER_ROLE_SUPPORT);
    const isAccountantUser =
      this.props?.user?.roles?.includes(USER_ROLE_ACCOUNTANT);

    const pathName = history?.location?.pathname;

    const isAppDashboard = pathName === "/app-dashboard";
    const isTenant = pathName === "/tenant";
    const isProfilePage = pathName === "/profile";
    const isVollmachtsdatenbankPage = pathName === "/vollmachtsdatenbank";
    const isBroadcastPage = pathName === "/broadcast";

    const isMDCAdmin = this.props?.user?.roles?.includes(USER_ROLE_MDC_ADMIN);
    const isExpertRole = this.props?.user?.roles?.includes(USER_ROLE_EXPERT);

    const isAllowedPOARead = hasRolePermissions(COMPONENT_IDS.POA, "read");
    return (
      (!this.props.authentication?.user || pathName !== "/register-popup") && (
        <>
          <div className={this.props?.classes?.headerBackground}>
            <Container maxWidth="false">
              <div>
                <AppBar
                  position="static"
                  className={this.props?.classes?.root}
                  style={{ background: "transparent", boxShadow: "none" }}
                >
                  <Grid
                    container
                    spacing={2}
                    paddingTop="4px"
                    alignItems={"center"}
                  >
                    <Grid item xs={5}>
                      <Grid
                        container
                        alignItems={"center"}
                        marginTop="1rem"
                        marginBottom="0.8rem"
                      >
                        <Grid marginLeft={"1rem"} container xs={2}>
                          {this.props.authentication?.loggedIn && (
                            <img
                              alt="KBA Cetrificate"
                              src={KBACertificate}
                              width={"70%"}
                              height={"65%"}
                              opacity={1}
                            />
                          )}
                          <Divider
                            orientation="vertical"
                            variant="middle"
                            flexItem
                            className={this.props.classes.responsiveDivider}
                          />
                        </Grid>

                        <Grid item xs={5.5}>
                          {this.props.authentication?.loggedIn && (
                            <a href="/">
                              <img
                                alt="My Digital Car"
                                src={carLogo}
                                width={"95%"}
                              />
                            </a>
                          )}
                        </Grid>
                        {pathName === "/app-dashboard" && !isAccountantUser && (
                          <Grid item xs={4}>
                            <label
                              className={
                                this.props?.classes?.administrationLabel
                              }
                            >
                              Administration
                            </label>
                          </Grid>
                        )}
                        {!(
                          (
                            this.props?.user?.roles?.includes("ADMIN") &&
                            !this.props?.user?.roles?.includes("APPROVER")
                          ) //for dual role admin+approver: button should be visible
                        ) &&
                          !this.props?.user?.roles?.includes("EXPERT") && //wont be avaialble for Expert role
                          !isAppDashboard &&
                          !isAccountantUser &&
                          !isProfilePage &&
                          !isVollmachtsdatenbankPage &&
                          !isBroadcastPage &&
                          !isTenant && (
                            <Grid item xs={4} marginBottom={"0.5rem"}>
                              <MultipleLoginDrawer
                                isApproverOrSupport={isApproverOrSupport}
                                isMutipleTenants={
                                  this.props?.user?.sec_group_ids?.length > 1 ||
                                  this.props?.user?.sec_tenant_ids?.length > 1
                                }
                              />
                            </Grid>
                          )}
                      </Grid>
                    </Grid>
                    <Grid item xs={2}>
                      <Grid
                        item
                        marginTop="1rem"
                        marginBottom="0.5rem"
                        height="5rem"
                        display="flex"
                        justifyContent="space-around"
                      >
                        {this.state.filePreview.length ? (
                          <img
                            className={this.props?.classes?.imgFluid}
                            src={this.state.filePreview}
                            alt={this.state.fileName}
                          />
                        ) : null}
                      </Grid>
                    </Grid>
                    <Grid item xs={5}>
                      <Grid
                        container
                        height="120%"
                        justifyContent="flex-end"
                        alignItems="center"
                        spacing={2}
                      >
                        {!isAppDashboard &&
                          !this.props?.user?.roles?.includes(
                            USER_ROLE_SUPPORT
                          ) &&
                          this.props?.user?.preferred_username && (
                            <Grid item xs={9}>
                              <GlobalAlert
                                handleNotification={this.handleNotification}
                                certificateDetails={
                                  this.props?.companyDetails?.gksDetailsPresent
                                }
                                userAuthority={this.props?.user?.roles}
                              />
                            </Grid>
                          )}

                        {this.props.authentication?.loggedIn && (
                          <Grid
                            item
                            xs={3}
                            display="flex"
                            justifyContent="flex-end"
                            alignItems="flex-end"
                          >
                            {isApprover && (
                              <Grid
                                marginRight="1rem"
                                item
                                display="flex"
                                flexDirection="unset"
                                position="relative"
                                top="0.75rem"
                                onClick={(e) => {
                                  this.handleOpen(e);
                                }}
                              >
                                <CSVExcelUploadImport />
                              </Grid>
                            )}

                            <Grid item marginRight="1rem">
                              <img
                                src={profileLogo}
                                alt="user pic"
                                onClick={this.handleClickProfile}
                                className={this.props?.classes?.cursorPointer}
                              />
                              <Menu
                                className={this.props?.classes?.profileList}
                                anchorEl={anchorProfile}
                                open={Boolean(anchorProfile)}
                                onClose={this.handleCloseProfile}
                                PaperProps={{
                                  style: {
                                    left: "97.188rem",
                                    transform:
                                      "translateX(-40%) translateY(58%)",
                                  },
                                }}
                              >
                                <MenuItem component={Link} to="/profile">
                                  Nutzerprofil
                                </MenuItem>
                                {this.props.user && (isAdmin || isAPIUser) && (
                                  <MenuItem component={Link} to="/admin">
                                    Mandantenprofil
                                  </MenuItem>
                                )}

                                <MenuItem
                                  onClick={() => this.handleClickDownloads()}
                                >
                                  <Grid
                                    container
                                    justifyContent="space-between"
                                  >
                                    <Grid item>Downloads</Grid>
                                    <Grid item marginLeft={"1rem"}>
                                      <RightArrowIcon />
                                    </Grid>
                                  </Grid>
                                </MenuItem>

                                <Menu
                                  className={
                                    this.props?.classes?.downloadsStyles
                                  }
                                  anchorEl={openDownloads}
                                  open={Boolean(openDownloads)}
                                  onClose={this.handleCloseDownloads}
                                  anchorOrigin={{ horizontal: "right" }}
                                >
                                  <MenuItem
                                    onClick={() =>
                                      this.downloadTemplate("Dauervollmacht")
                                    }
                                  >
                                    <DownloadFileIcon
                                      className={
                                        this.props?.classes
                                          ?.downloadFileIconStyles
                                      }
                                    />
                                    Dateiupload-Template Dauervollmacht
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() =>
                                      this.downloadTemplate("Einzelvollmacht")
                                    }
                                  >
                                    <DownloadFileIcon
                                      className={
                                        this.props?.classes
                                          ?.downloadFileIconStyles
                                      }
                                    />
                                    Dateiupload-NP Einzelvollmacht
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() =>
                                      this.downloadTemplate("SEPA")
                                    }
                                  >
                                    <DownloadFileIcon
                                      className={
                                        this.props?.classes
                                          ?.downloadFileIconStyles
                                      }
                                    />
                                    Dateiupload-Template SEPA-Mandat
                                  </MenuItem>
                                </Menu>

                                {this.props.user &&
                                  (isMDCAdmin || isExpertRole) && (
                                    <MenuItem component={Link} to="/broadcast">
                                      Nachrichten
                                    </MenuItem>
                                  )}
                                {isAllowedPOARead && (
                                  <MenuItem
                                    component={Link}
                                    to="/vollmachtsdatenbank"
                                    onClick={this.handleOriginNavigation}
                                  >
                                    Vollmachtsdatenbank
                                  </MenuItem>
                                )}
                                <MenuItem onClick={this.onLogout}>
                                  Abmelden
                                </MenuItem>
                              </Menu>
                            </Grid>
                            <Grid
                              item
                              display="flex"
                              flexDirection="unset"
                              position="relative"
                              top="0.75rem"
                              onClick={() => {
                                if (
                                  !this.state?.notificationsData?.length ||
                                  this.state?.notificationsData?.length === 0
                                ) {
                                  return false;
                                }
                                this.setState({
                                  showNotificationDialog:
                                    !showNotificationDialog,
                                });
                              }}
                            >
                              <MDCBadge
                                badgeContent={
                                  this.state?.notificationsData?.length || 0
                                }
                                icon={
                                  <NotificationBellIcon
                                    color={theme.palette.MDCColors.color18}
                                  />
                                }
                              />
                            </Grid>
                          </Grid>
                        )}
                        {showNotificationDialog && (
                          <Grid
                            item
                            position="absolute"
                            top="10%"
                            width="35.875rem"
                            zIndex={1}
                            paddingTop="0px !important"
                            marginTop="24px"
                          >
                            <NotificationDialog
                              notificationsData={this.state.notificationsData}
                            />
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </AppBar>
              </div>
            </Container>
          </div>

          {this.state.groupStatusMessages && (
            <StatusServiceMessages
              statusServiceData={this.state.groupStatusMessages}
              showMessageDetailDialog={this.showMessageDetailDialog}
            />
          )}
          {this.state.showMessageDetail && this.state.messageDetails && (
            <MessageDetailsPopupDialog
              show={this.state.showMessageDetail}
              handlePopupClose={() => {
                this.setState({
                  showMessageDetail: false,
                });
              }}
              messageDetails={this.state.messageDetails}
            />
          )}

          {!isMDCAdmin &&
            this.state.showNewsAndUpdates &&
            this.props?.newAndUpdatesListData?.length > 0 &&
            sessionStorage.getItem("closeNewAndUpdatePopup") !== "false" && (
              <NewsAndUpdatesOverviewPopup
                show={this.state?.showNewsAndUpdates}
                handleClose={this.handleNewAndUpdatesClose}
              />
            )}

          {/* Session timeout and logout user warning timer */}
          {this.props.authentication?.showSessionTimeoutWarning && (
            <SessionTimeoutWarning
              show={this.props.authentication?.showSessionTimeoutWarning}
              handleLogout={() => {
                this.logoutOnSessionExpiry();
              }}
            />
          )}
        </>
      )
    );
  }
}

function mapState(state) {
  return {
    authentication: state.authentication,
    user: state.authentication?.user,
    companyDetails: state?.authentication?.companyDetails,
    excelTempalte: state.authentication.excelTempalte,
    tempaltePDF: state.authentication.tempaltePDF,
    dashboardTableQuery: state.vorgangeListReducer?.dashboardTableQuery,
    newAndUpdatesListData: state.finWhiteListReducer?.newAndUpdatesListData,
  };
}

const actionCreators = {
  logout: userActions.logout,
  getTokenForWebsocket: notificationActions.getTokenForWebsocket,
  getGroupStatusMessages: notificationActions.getGroupStatusMessages,
  getCompanyDetails: userActions.getCompanyDetails,
  getTempaltePDF: userActions.getTempaltePDF,
  getVorgangeList: vorgangeListActions.getVorgangeList,
  isDashboardTableEinreichenNotification:
    vorgangeListActions.isDashboardTableEinreichenNotification,
  getFinWhiteListStatusDetails:
    finWhiteListActions.getFinWhiteListStatusDetails,
  getCreateTenantStatus: appLoginDashboardActions.getCreateTenantStatus,
  getNewsAndUpdatesList: finWhiteListActions.getNewsAndUpdatesList,
  getVorgangUpdatedIdFromSocketEvent:
    socketActions.getVorgangUpdatedIdFromSocketEvent,
  getVorgangQESUpdatedFromSocketEvent:
    socketActions.getVorgangQESUpdatedFromSocketEvent,
  getCSVUploadedAndErrorFile: csvImportExportAction.getCSVUploadedAndErrorFile,
  isDashboardTableCSVImportNotification:
    vorgangeListActions.isDashboardTableCSVImportNotification,
  showLogoutWarningTimer: userActions.showLogoutWarningTimer,
};

export default connect(mapState, actionCreators)(withStyles(styles)(Header));
